import { render, staticRenderFns } from "./TheHistoryList.vue?vue&type=template&id=a5ed220e"
import script from "./TheHistoryList.vue?vue&type=script&lang=js"
export * from "./TheHistoryList.vue?vue&type=script&lang=js"
import style0 from "./TheHistoryList.vue?vue&type=style&index=0&id=a5ed220e&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports